export const AdditionalInfoPhoneAgent = 'AdditionalInfoPhoneAgent'
export const AddMortgage = 'AddMortgage'
export const AdjustedHomeInsuranceDate = 'AdjustedHomeInsuranceDate'
export const AirDNARequest = 'AirDNARequest'
export const AirDNALoaded = 'AirDNALoaded'
export const AVMDifferenceLearnMoreClicked = 'AVMDifferenceLearnMoreClicked'
export const AVMDifferenceLearnMoreLoad = 'AVMDifferenceLearnMoreLoad'
export const AVMDifferenceToolTipLoad = 'AVMDifferenceToolTipLoad'
export const AvmDifferenceTuneValue = 'AvmDifferenceTuneValue'
export const BuyerOnboardingTunedPricePoint = 'BuyerOnboardingTunedPricePoint'
export const CallRealEstateAgent = 'CallRealEstateAgent'
export const ChangeTheseValues = 'ChangeTheseValues'
export const ClickFacebookShare = 'ClickFacebookShare'
export const CloseAvmDifferenceToolTipClick = 'CloseAvmDifferenceToolTipClick'
export const CloseLowConfidenceToolTipClick = 'CloseLowConfidenceToolTipClick'
export const CloseNonDisclosureToolTipClick = 'CloseNonDisclosureToolTipClick'
export const CMAQuestionAnswered = 'CMAQuestionAnswered'
export const CMARequest = 'CMARequest'
export const CMARequestFinished = 'CMARequestFinished'
export const CMARequestSkipped = 'CMARequestSkipped'
export const ConfirmDetailsClick = 'ConfirmDetailsClick'
export const CopyShareLink = 'CopyShareLink'
export const CoveredExploreOptionsClick = 'CoveredExploreOptionsClick'
export const CoveredRecommendHelpfulNo = 'CoveredRecommendHelpfulNo'
export const CoveredRecommendHelpfulYes = 'CoveredRecommendHelpfulYes'
export const CoveredWhyShouldYouCareClick = 'CoveredWhyShouldYouCareClick'
export const DeleteMortgage = 'DeleteMortgage'
export const DirectMessage = 'DirectMessage'
export const DIYUpdatePayments = 'DIYUpdatePayments'
export const EmailRealEstateAgent = 'EmailRealEstateAgent'
export const EquitySmartSearchCalculationClick =
  'EquitySmartSearchCalculationClick'
export const EstPMILoaded = 'EstPMILoaded'
export const HomeInsuranceCancelClick = 'HomeInsuranceCancelClick'
export const HomeInsuranceSaveClick = 'HomeInsuranceSaveClick'
export const HomeInsuranceSnoozeClick = 'HomeInsuranceSnoozeClick'
export const HomePreviewEmailEntered = 'HomePreviewEmailEntered'
export const HomePreviewLoaded = 'HomePreviewLoaded'
export const HomePreviewSignUpComplete = 'HomePreviewSignUpComplete'
export const InstantOfferNavigateBack = 'InstantOfferNavigateBack'
export const InviteAnotherHomeowner = 'InviteAnotherHomeowner'
export const InterestPayMoreMonthly = 'InterestPayMoreMonthly'
export const KnownPMILoaded = 'KnownPMILoaded'
export const LearnMore = 'LearnMore'
export const LowConfidenceThumbsDownClick = 'LowConfidenceThumbsDownClick'
export const LowConfidenceWarnLoad = 'LowConfidenceWarnLoad'
export const LowConfidenceWarnTuneClick = 'LowConfidenceWarnTuneClick'
export const LowConfidenceLooksGoodClick = 'LowConfidenceLooksGoodClick'
export const MarketPanelToggledAll = 'MarketPanel-ScopeToggled-All'
export const MarketPanelToggledQuartile = 'MarketPanel-ScopeToggled-Quartile'
export const ModuleShown = 'ModuleShown'
export const MoreDetailsOnThisClick = 'MoreDetailsOnThisClick'
export const MortgageCoachNavigateBack = 'MortgageCoachNavigateBack'
export const NDStateLooksGoodClick = 'NDStateLooksGoodClick'
export const NDStateWarnLoad = 'NDStateWarnLoad'
export const NDStateWarnTuneClick = 'NDStateWarnTuneClick'
export const NonDisclosureLearnMoreClicked = 'NonDisclosureLearnMoreClicked'
export const NonDisclosureLooksGoodClicked = 'NonDisclosureLooksGoodClicked'
export const NonDisclosureLearnMoreLoad = 'NonDisclosureLearnMoreLoad'
export const NonDisclosureToolTipLoad = 'NonDisclosureToolTipLoad'
export const NonDisclosureTuneValue = 'NonDisclosureTuneValue'
export const NightlyAirbnbClick = 'NightlyAirbnbClick'
export const NightlyLearnMore = 'NightlyLearnMore'
export const NightlyUpdateNights = 'NightlyUpdateNights'
export const NightlyUpdatePrice = 'NightlyUpdatePrice'
export const NightlyVRBOClick = 'NightlyVRBOClick'
export const NumbersLookRight = 'NumbersLookRight'
export const PreviewBuyConfirm = 'PreviewBuy-AskName'
export const PreviewBuyMounted = 'PreviewBuy-Open'
export const PreviewBuySubmit = 'PreviewBuy-Submit'
export const PreviewHomeConfirm = 'PreviewHome-AskDetails'
export const PreviewHomeMounted = 'PreviewHome-Open'
export const PreviewHomeSubmit = 'PreviewHome-Submit'
export const SaveMortgage = 'SaveMortgage'
export const ScrolledIntoView = 'ScrolledIntoView'
export const StartYourSearchClick = 'StartYourSearchClick'
export const TuneNavigateBack = 'TuneNavigateBack'
export const UpdateYourPolicyClick = 'UpdateYourPolicyClick'
export const VerifySellingPriceClick = 'VerifySellingPriceClick'
export const ViewCashoutFromWIN = 'ViewCashoutFromWIN'
export const ViewDreamHomeFromWIN = 'ViewDreamHomeFromWIN'
export const ViewEssFromWIN = 'ViewEssFromWIN'
export const ViewHomeInsuranceFromWIN = 'ViewHomeInsuranceFromWIN'
export const ViewMarketSpotlight = 'ViewMarketSpotlight'
export const ViewShareFromBottomDigest = 'ViewShareFromBottomDigest'
export const ViewRefiFromWIN = 'ViewRefiFromWIN'
export const ViewShareFromWIN = 'ViewShareFromWIN'

export const EVENTS_LABELS = {
  CashOutModule: 'CashOutModule',
  EstimatedValueModule: 'EstimatedValueModule',
  HomeInsuranceModule: 'HomeInsuranceModule',
  PaidSoFarSection: 'PaidSoFarSection',
  PrincipalPaymentsSection: 'PrincipalPaymentsSection',
  PmiSection: 'PmiSection',
  PurchasingPowerModule: 'PurchasingPowerModule',
  RefiScenariosSection: 'RefiScenariosSection',
  ReferralSection: 'ReferralSection',
  ReverseMortgageSection: 'ReverseMortgageSection'
}

export const EVENTS_CATEGORIES = {
  [AdditionalInfoPhoneAgent]: 1,
  [AddMortgage]: 2,
  [AdjustedHomeInsuranceDate]: 2,
  [AirDNALoaded]: 3,
  [AirDNARequest]: 3,
  [AVMDifferenceLearnMoreClicked]: 2,
  [AVMDifferenceLearnMoreLoad]: 2,
  [AVMDifferenceToolTipLoad]: 2,
  [AvmDifferenceTuneValue]: 2,
  [BuyerOnboardingTunedPricePoint]: 2,
  [CallRealEstateAgent]: 1,
  [ChangeTheseValues]: 3,
  [ClickFacebookShare]: 2,
  [CMARequest]: 1,
  [CMAQuestionAnswered]: 2,
  [CMARequestFinished]: 1,
  [CMARequestSkipped]: 1,
  [CloseAvmDifferenceToolTipClick]: 2,
  [CloseLowConfidenceToolTipClick]: 2,
  [CloseNonDisclosureToolTipClick]: 2,
  [ConfirmDetailsClick]: 2,
  [CopyShareLink]: 2,
  [CoveredExploreOptionsClick]: 2,
  [CoveredRecommendHelpfulNo]: 2,
  [CoveredRecommendHelpfulYes]: 2,
  [CoveredWhyShouldYouCareClick]: 2,
  [DeleteMortgage]: 2,
  [DirectMessage]: 1,
  [DIYUpdatePayments]: 3,
  [EmailRealEstateAgent]: 1,
  [EquitySmartSearchCalculationClick]: 2,
  [EstPMILoaded]: 1,
  [HomeInsuranceCancelClick]: 2,
  [HomeInsuranceSaveClick]: 2,
  [HomeInsuranceSnoozeClick]: 2,
  [HomePreviewEmailEntered]: 1,
  [HomePreviewLoaded]: 1,
  [HomePreviewSignUpComplete]: 1,
  [InstantOfferNavigateBack]: 2,
  [InviteAnotherHomeowner]: 1,
  [KnownPMILoaded]: 1,
  [LearnMore]: 1,
  [LowConfidenceLooksGoodClick]: 2,
  [LowConfidenceWarnLoad]: 2,
  [LowConfidenceWarnTuneClick]: 2,
  [LowConfidenceThumbsDownClick]: 2,
  [MarketPanelToggledAll]: 2,
  [MarketPanelToggledQuartile]: 2,
  [ModuleShown]: 2,
  [MoreDetailsOnThisClick]: 2,
  [MortgageCoachNavigateBack]: 2,
  [NDStateLooksGoodClick]: 2,
  [NDStateWarnLoad]: 2,
  [NDStateWarnTuneClick]: 2,
  [NightlyAirbnbClick]: 1,
  [NightlyLearnMore]: 1,
  [NightlyUpdateNights]: 3,
  [NightlyUpdatePrice]: 3,
  [NightlyVRBOClick]: 1,
  [NonDisclosureLearnMoreClicked]: 2,
  [NonDisclosureLearnMoreLoad]: 2,
  [NonDisclosureLooksGoodClicked]: 2,
  [NonDisclosureToolTipLoad]: 2,
  [NonDisclosureTuneValue]: 2,
  [NumbersLookRight]: 3,
  [PreviewBuyConfirm]: 3,
  [PreviewBuyMounted]: 3,
  [PreviewBuySubmit]: 3,
  [PreviewHomeConfirm]: 3,
  [PreviewHomeMounted]: 3,
  [PreviewHomeSubmit]: 3,
  [SaveMortgage]: 2,
  [ScrolledIntoView]: 3,
  [StartYourSearchClick]: 3,
  [TuneNavigateBack]: 2,
  [UpdateYourPolicyClick]: 2,
  [VerifySellingPriceClick]: 3,
  [ViewCashoutFromWIN]: 2,
  [ViewDreamHomeFromWIN]: 2,
  [ViewEssFromWIN]: 2,
  [ViewHomeInsuranceFromWIN]: 2,
  [ViewMarketSpotlight]: 2,
  [ViewRefiFromWIN]: 2,
  [ViewShareFromBottomDigest]: 2,
  [ViewShareFromWIN]: 2
}

export const HOME_FACTS_TRACKING_PROGRESS = {
  0: 'Ruler',
  20: 'Bedrooms',
  40: 'Bathrooms',
  60: 'Sq ft',
  80: 'Additional updates',
  100: 'Finished'
}
